module.exports = {
	"AccountAdd.btn.add": "Add account",
	"AccountAdd.error.create": "Error creating account. {errors}",
	"AccountAdd.error.message.create": "Failed to create account: {errors}.",
	"AccountAdd.error.server": "Server error. Try again later.",
	"AccountAdd.success.created": "Account created",
	"AccountAdd.success.message.created": "Account created successfully.",
	"AccountAdd.validation.email.this_value_is_not_a_valid_email_address": "Please enter a valid email.",
	"AccountAdd.validation.email.this_value_should_not_be_blank": "Email cannot be empty.",
	"AccountAdd.validation.password.this_value_should_not_be_blank": "Password cannot be empty.",
	"AccountAdd.validation.username.this_value_should_not_be_blank": "Username cannot be empty.",
	"AccountEditing.2FA.notEnabled": "2FA was not enabled for this account",
	"AccountEditing.2FA.resetSuccess": "Two-factor authentication reset",
	"AccountEditing.admin.error": "Error changing administrator status",
	"AccountEditing.admin.granted": "User has been appointed as project administrator",
	"AccountEditing.admin.label": "Project Administrator",
	"AccountEditing.admin.revoked": "Administrator privileges revoked",
	"AccountEditing.admin.save": "Save",
	"AccountEditing.admin.saving": "Saving...",
	"AccountEditing.btn.reset2FA": "Reset 2FA",
	"AccountEditing.btn.save": "Save",
	"AccountEditing.btn.saving": "Saving...",
	"AccountEditing.btn.sendNewPassword": "Send new password",
	"AccountEditing.empty": "No account selected",
	"AccountEditing.error.reset2FA": "Error resetting 2FA",
	"AccountEditing.error.save": "Error saving account",
	"AccountEditing.error.sendPassword": "Error sending new password",
	"AccountEditing.global.configure": "Configure permissions",
	"AccountEditing.global.enable": "Enable global permissions",
	"AccountEditing.global.hint": "Applied to all user projects",
	"AccountEditing.global.modalTitle": "User global permissions",
	"AccountEditing.global.readOnlyMessage": "Global permissions are used. To change them, go to the \"Global permissions\" section.",
	"AccountEditing.global.title": "Global permissions",
	"AccountEditing.label.createdAt": "Creation date",
	"AccountEditing.label.id": "ID",
	"AccountEditing.label.lastLoginAt": "Last login date",
	"AccountEditing.label.neverLoggedIn": "Never logged in",
	"AccountEditing.label.updatedAt": "Last updated",
	"AccountEditing.loading.data": "Loading...",
	"AccountEditing.loading.saving": "Saving...",
	"AccountEditing.modal.permissions": "Permissions on project {project}",
	"AccountEditing.modal.permissionsGlobal": "Permissions on project {project} (global)",
	"AccountEditing.status.active": "Active",
	"AccountEditing.status.blocked": "Blocked",
	"AccountEditing.status.closed": "Closed",
	"AccountEditing.status.inactive": "Inactive",
	"AccountEditing.status.passwordConfirm": "The account «{account}» password has been changed. Save changes?",
	"AccountEditing.success.passwordSent": "New password sent to user's email",
	"AccountEditing.success.saved": "Account changes saved",
	"AccountEditing.title.account": "Account",
	"AccountEditing.title.contacts": "Contacts",
	"AccountEditing.title.merchants": "Merchants",
	"AccountSearchList.empty": "No linked accounts",
	"AccountSearchList.label.email": "Email",
	"AccountSearchList.label.id": "ID",
	"AccountSearchList.label.name": "Name",
	"AccountSearchList.noResults": "Nothing found",
	"AccountSearchList.search.placeholder": "Search by ID, name, email...",
	"Accounts.button.add": "Add",
	"Accounts.modal.addTitle": "Add account",
	"Accounts.title.accountsList": "Accounts list",
	"Accounts.title.terminalsList": "Terminals",
	"AccountsFilters.btn.filter": "Filter",
	"AccountsFilters.status.active": "Active",
	"AccountsFilters.status.blocked": "Blocked",
	"AccountsFilters.status.closed": "Closed",
	"AccountsFilters.status.inactive": "Inactive",
	"AccountsFilters.title.status": "Status",
	"AccountsList.empty": "No accounts found",
	"AccountsList.status.active": "Active",
	"AccountsList.status.blocked": "Blocked",
	"AccountsList.status.closed": "Closed",
	"AccountsList.status.inactive": "Inactive",
	"AccountsList.table.createdAt": "Created",
	"AccountsList.table.email": "Email",
	"AccountsList.table.id": "ID",
	"AccountsList.table.status": "Status",
	"AccountsList.table.user": "User",
	"AdminFiltersToggle.label": "Filters",
	"AdministrationMenu.list.analytics": "Analytics",
	"AdministrationMenu.list.finance": "Finance",
	"AdministrationMenu.list.payments": "Transactions",
	"AdministrationMenu.list.registries": "Registries",
	"AdministrationMenu.list.reports": "Reports",
	"AdministrationMenu.list.settings": "Settings",
	"AdministrationMenu.list.stats": "Statistics",
	"AdministrationMenu.list.support": "Support",
	"AdministrationMenu.title.accounts": "Settings",
	"AdministrationMenu.title.accountsList": "Accounts list",
	"AdministrationMenu.title.adminAudit": "Activity log",
	"AdministrationMenu.title.antifraud": "Antifraud",
	"AdministrationMenu.title.payoutHolds": "Held payouts",
	"AdministrationMenu.title.console": "Admin panel",
	"AdministrationMenu.title.constructor": "Constructor",
	"AdministrationMenu.title.crmPayoutRequests": "CRM requests",
	"AdministrationMenu.title.crmSbpPayoutRequests": "CRM SBP requests",
	"AdministrationMenu.title.deposits": "Deposits",
	"AdministrationMenu.title.disputes": "Disputes",
	"AdministrationMenu.title.frod": "Anti-frod",
	"AdministrationMenu.title.payments": "Payments",
	"AdministrationMenu.title.projectsList": "Projects",
	"AdministrationMenu.title.reconciliation": "Reconciliation",
	"AdministrationMenu.title.registries": "Registries",
	"AdministrationMenu.title.secretChats": "Secret chats",
	"AdministrationMenu.title.settlements": "Settlements",
	"AdministrationMenu.title.terminalsList": "Terminals",
	"AdministrationMenu.title.tickets": "Support tickets",
	"AdministrationMenu.title.trafficMonitoring": "Traffic monitoring",
	"AdministrationMenu.title.transactionAudit": "Transaction Audit",
	"AntiFraud.add": "Add",
	"AntiFraud.details.delete": "Delete",
	"AntiFraud.details.title": "Record details",
	"AntiFraud.details.unblock": "Unblock",
	"AntiFraud.filter.apply": "Apply",
	"AntiFraud.filter.kind": "Data type",
	"AntiFraud.filter.reset": "Reset",
	"AntiFraud.filter.source": "Source",
	"AntiFraud.filter.status": "Status",
	"AntiFraud.form.expiresAt": "Expiration (optional)",
	"AntiFraud.form.kind": "Data type",
	"AntiFraud.form.reason": "Block reason",
	"AntiFraud.form.source": "Source",
	"AntiFraud.form.submit": "Add block",
	"AntiFraud.form.value": "Value",
	"AntiFraud.list.createdAt": "Created",
	"AntiFraud.list.empty": "No records",
	"AntiFraud.list.expiresAt": "Expires",
	"AntiFraud.list.hits": "Hits",
	"AntiFraud.list.id": "ID",
	"AntiFraud.list.kind": "Type",
	"AntiFraud.list.reason": "Reason",
	"AntiFraud.list.source": "Source",
	"AntiFraud.list.status": "Status",
	"AntiFraud.list.value": "Value",
	"AntiFraud.modal.addTitle": "Add block",
	"AntiFraud.search.mask": "Search by mask",
	"AntiFraud.search.maskPlaceholder": "Enter part of card number, IP or phone...",
	"AntiFraud.stats.title": "Statistics",
	"AntiFraud.status.blocked": "Blocked",
	"AntiFraud.status.unblocked": "Unblocked",
	"AntiFraud.title": "Antifraud records",
	"AntiFraudDetails.delete": "Delete",
	"AntiFraudDetails.title": "Record details",
	"AntiFraudDetails.unblock": "Unblock",
	"AntiFraudFilters.btn.filter": "Filter",
	"AntiFraudFilters.btn.reset": "Reset",
	"AntiFraudFilters.status.blocked": "Blocked",
	"AntiFraudFilters.status.unblocked": "Unblocked",
	"AntiFraudFilters.title.kind": "Data type",
	"AntiFraudFilters.title.source": "Source",
	"AntiFraudFilters.title.status": "Status",
	"AntiFraudForm.error.create": "Error adding record",
	"AntiFraudForm.error.kindRequired": "Select a data type",
	"AntiFraudForm.error.valueRequired": "Enter a value",
	"AntiFraudForm.expiresAt": "Expiration (optional)",
	"AntiFraudForm.expiresAt.hint": "Leave empty for an unlimited block",
	"AntiFraudForm.hint.card_pan": "Card number (16-19 digits)",
	"AntiFraudForm.hint.inn": "INN (10 or 12 digits)",
	"AntiFraudForm.hint.ip": "IP address",
	"AntiFraudForm.hint.name": "Full name",
	"AntiFraudForm.hint.phone": "Phone number in format 79001234567",
	"AntiFraudForm.hint.sbp_phone": "SBP phone in format 79001234567",
	"AntiFraudForm.kind": "Data type",
	"AntiFraudForm.kind.placeholder": "-- Select type --",
	"AntiFraudForm.placeholder.cardPan": "4111111111111111",
	"AntiFraudForm.placeholder.inn": "1234567890",
	"AntiFraudForm.placeholder.ip": "192.168.1.1",
	"AntiFraudForm.placeholder.phone": "79001234567",
	"AntiFraudForm.reason": "Block reason",
	"AntiFraudForm.reason.default": "Manual block by administrator",
	"AntiFraudForm.submit": "Add block",
	"AntiFraudForm.value": "Value",
	"AntiFraudForm.value.placeholder": "Enter value",
	"AntiFraudList.empty": "No records",
	"AntiFraudList.status.blocked": "Blocked",
	"AntiFraudList.status.unblocked": "Unblocked",
	"AntiFraudList.table.hits": "Hits",
	"AntiFraudList.table.id": "ID",
	"AntiFraudList.table.kind": "Type",
	"AntiFraudList.table.lastSeen": "Last seen",
	"AntiFraudList.table.reason": "Reason",
	"AntiFraudList.table.source": "Source",
	"AntiFraudList.table.status": "Status",
	"AntiFraudList.table.value": "Value",
	"AuditLogsFilters.button.apply": "Apply",
	"AuditLogsFilters.button.reset": "Reset",
	"AuditLogsFilters.label.action": "Action",
	"AuditLogsFilters.label.admin": "Administrator",
	"AuditLogsFilters.label.entityType": "Object type",
	"AuditLogsFilters.label.periodFrom": "Period from",
	"AuditLogsFilters.label.periodTo": "to",
	"AuditLogsFilters.label.search": "Search",
	"AuditLogsFilters.option.all": "All",
	"AuditLogsFilters.option.allActions": "All actions",
	"AuditLogsFilters.option.allTypes": "All types",
	"AuditLogsFilters.placeholder.search": "Search by username or object",
	"BalanceWidget.actualBalance": "Actual balance",
	"BalanceWidget.section.payin": "Payment intake",
	"BalanceWidget.section.payout": "Payouts",
	"BalanceWidget.settlementLabel.reimbursement": "Reimbursement",
	"BalanceWidget.settlementLabel.reserve": "Reserve",
	"BalanceWidget.transactionBalance": "Transaction balance",
	"Confirmation.btn.cabinet": "Go to your account",
	"Confirmation.btn.login": "Log in",
	"Confirmation.btn.retry": "Try again",
	"Confirmation.text.error": "The address may have already been confirmed with this link, or a new email change was requested. Check the email in your profile and request the change again if needed.",
	"Confirmation.text.failed": "Check your internet connection and try again. If the error persists, contact support.",
	"Confirmation.text.success": "The new address is saved in your profile. Emails and notifications will now be sent to it.",
	"Confirmation.title.error": "This link is no longer valid",
	"Confirmation.title.failed": "Could not confirm your email",
	"Confirmation.title.success": "Email confirmed",
	"Console.created": "Created",
	"Console.error": "Error",
	"Console.loading": "Loading…",
	"Console.pending": "Pending",
	"Console.title": "Admin Panel",
	"Console.transactionsTitle": "Transactions requiring attention",
	"ContractsTable.empty": "No contracts",
	"ContractsTable.menu.edit": "Edit",
	"ContractsTable.menu.newPSA": "New PSA for contract",
	"ContractsTable.menu.psaList": "PSA list",
	"ContractsTable.table.date": "Date",
	"ContractsTable.table.name": "Name",
	"ContractsTable.table.project": "Project",
	"ContractsTable.table.psaCount": "PSA count",
	"ContractsTable.table.psaProcessing": "PSA in processing",
	"CountryTop.table.country": "Country",
	"CountryTop.table.declined": "Declined",
	"CountryTop.table.successful": "Successful",
	"CountryTop.table.transactions": "Transactions",
	"CountryTop.table.turnover": "Turnover",
	"CrmPayout.action.bulkDecline": "Decline selected",
	"CrmPayout.action.decline": "Decline",
	"CrmPayout.action.formRegistry": "Form registry",
	"CrmPayout.action.retry": "Retry",
	"CrmPayout.action.selected": "Selected: {count}",
	"CrmPayout.detail.title": "Request",
	"CrmPayout.empty": "No requests found",
	"CrmPayout.filters.apply": "Apply",
	"CrmPayout.filters.payoutType": "Payout Type",
	"CrmPayout.filters.reset": "Reset",
	"CrmPayout.filters.status": "Status",
	"CrmPayout.filters.title": "Filters",
	"CrmPayout.search.cardMask": "card mask",
	"CrmPayout.search.cardMask.placeholder": "Enter card mask (e.g. 411111)",
	"CrmPayout.search.externalReference": "external ID",
	"CrmPayout.search.externalReference.placeholder": "Enter external ID",
	"CrmPayout.search.fullName": "full name",
	"CrmPayout.search.fullName.placeholder": "Enter recipient name",
	"CrmPayout.stats.title": "Statistics",
	"CrmPayout.stats.total": "Total",
	"CrmPayout.table.amount": "Amount",
	"CrmPayout.table.card": "Card/Phone",
	"CrmPayout.table.date": "Date",
	"CrmPayout.table.fullName": "Full Name",
	"CrmPayout.table.id": "ID",
	"CrmPayout.table.merchant": "Merchant",
	"CrmPayout.table.status": "Status",
	"CrmPayout.table.type": "Type",
	"CrmPayout.title": "CRM Payout Requests",
	"CrmSbpPayout.title": "CRM SBP Payout Requests",
	"CrmPayoutBoard.type.sbp": "SBP",
	"CrmPayoutDetails.action.cancel": "Cancel",
	"CrmPayoutDetails.action.confirm": "Confirm",
	"CrmPayoutDetails.action.confirmDecline": "Confirm decline",
	"CrmPayoutDetails.action.decline": "Decline",
	"CrmPayoutDetails.action.moveBack": "Move back to awaiting",
	"CrmPayoutDetails.action.moveToSuccess": "Move to success",
	"CrmPayoutDetails.action.sendToAntifraud": "Send to antifraud",
	"CrmPayoutDetails.antifraud.toggle": "Antifraud",
	"CrmPayoutDetails.decline.placeholder": "Decline reason...",
	"CrmPayoutDetails.decline.title": "Decline reason",
	"CrmPayoutDetails.declineReasonRequired": "Specify the decline reason",
	"CrmPayoutDetails.error.generic": "Error: {msg}",
	"CrmPayoutDetails.error.unknown": "Unknown error",
	"CrmPayoutDetails.info.card": "Card",
	"CrmPayoutDetails.info.createdAt": "Created at",
	"CrmPayoutDetails.info.description": "Description",
	"CrmPayoutDetails.info.documentDate": "Document date",
	"CrmPayoutDetails.info.documentNumber": "Document number",
	"CrmPayoutDetails.info.email": "Email",
	"CrmPayoutDetails.info.fullName": "Full name",
	"CrmPayoutDetails.info.merchant": "Merchant",
	"CrmPayoutDetails.info.phone": "Phone",
	"CrmPayoutDetails.info.registry": "Registry",
	"CrmPayoutDetails.info.transaction": "Transaction",
	"CrmPayoutDetails.info.updatedAt": "Updated",
	"CrmPayoutDetails.status.antifraud": "Antifraud",
	"CrmPayoutDetails.status.awaitingPayout": "Awaiting payout",
	"CrmPayoutDetails.status.created": "Created",
	"CrmPayoutDetails.status.error": "Error",
	"CrmPayoutDetails.status.registry": "In registry",
	"CrmPayoutDetails.status.rejected": "Rejected",
	"CrmPayoutDetails.status.success": "Success",
	"CrmPayoutDetails.success.feePlaceholder": "Fee (optional)",
	"CrmPayoutDetails.success.movedToSuccess": "Request moved to success",
	"CrmPayoutDetails.success.sentToAntifraud": "Sent to antifraud",
	"CrmPayoutDetails.title": "Request #{id}",
	"CrmPayoutList.status.antifraud": "Antifraud",
	"CrmPayoutList.status.created": "Created",
	"CrmPayoutList.status.error": "Error",
	"CrmPayoutList.status.processing": "Processing",
	"CrmPayoutList.status.registry": "In registry",
	"CrmPayoutList.status.rejected": "Rejected",
	"CrmPayoutList.status.success": "Success",
	"Dashboard.help.payout": "Payout: {count}",
	"Dashboard.help.purchase": "Purchase: {count}",
	"Dashboard.help.recurrent": "Recurrent: {count}",
	"Dashboard.title.balance": "Balance",
	"Dashboard.title.balanceOnDate": "Balance as of {date}",
	"Dashboard.title.errors": "Errors",
	"Dashboard.title.paymentSystems": "Payment systems",
	"Dashboard.title.paymentsThisMonth": "Payments for {month}",
	"Dashboard.title.paymentsToday": "Payments today",
	"Dashboard.title.refills": "Refills",
	"Dashboard.title.statistics": "Statistics",
	"Dashboard.title.successful": "Successful",
	"DateRange.days30": "30 days",
	"DateRange.days7": "7 days",
	"DateRange.from": "From:",
	"DateRange.halfYear": "6 months",
	"DateRange.month": "month",
	"DateRange.placeholder": "Select period",
	"DateRange.quickSelect": "Quick select",
	"DateRange.timeLabel": "Time:",
	"DateRange.title": "Period",
	"DateRange.to": "To:",
	"DateRange.today": "today",
	"DateRange.week": "week",
	"DateRange.yesterday": "yesterday",
	"DisputeDetails.action.archive": "Archive",
	"DisputeDetails.action.resolved": "Resolved",
	"DisputeDetails.action.saveNote": "Save note",
	"DisputeDetails.action.toWork": "Move to work",
	"DisputeDetails.attachments.file": "File",
	"DisputeDetails.attachments.open": "Open",
	"DisputeDetails.attachments.photo": "Photo",
	"DisputeDetails.attachments.title": "Attachments ({count})",
	"DisputeDetails.error.check": "Check failed",
	"DisputeDetails.error.fileLoad": "Failed to get file",
	"DisputeDetails.error.fileOpen": "Failed to open file",
	"DisputeDetails.error.generic": "Error: {message}",
	"DisputeDetails.error.saveNote": "Failed to save note",
	"DisputeDetails.error.unknown": "Unknown error",
	"DisputeDetails.error.updateStatus": "Failed to update status",
	"DisputeDetails.label.attachment": "Attachment:",
	"DisputeDetails.label.chat": "Chat:",
	"DisputeDetails.label.date": "Date:",
	"DisputeDetails.label.sender": "Sender:",
	"DisputeDetails.linked.checkProvider": "Check with provider",
	"DisputeDetails.linked.currentStatus": "Current status:",
	"DisputeDetails.linked.lastCheck": "Last check: {date}",
	"DisputeDetails.linked.merchant": "Merchant:",
	"DisputeDetails.linked.providerResponse": "Provider response:",
	"DisputeDetails.linked.statusAtCreation": "Status at creation:",
	"DisputeDetails.linked.transaction": "Linked transaction:",
	"DisputeDetails.resolution.placeholder": "Note...",
	"DisputeDetails.resolution.resolvedBy": "Resolved by: {name} ({date})",
	"DisputeDetails.section.message": "Message",
	"DisputeDetails.section.resolution": "Resolution",
	"DisputeDetails.section.transaction": "Transaction",
	"DisputeDetails.title": "Dispute",
	"DisputeDetails.transaction.amount": "Amount:",
	"DisputeDetails.transaction.check": "Check",
	"DisputeDetails.transaction.merchant": "Merchant:",
	"DisputeDetails.transaction.ourStatus": "Our status:",
	"DisputeDetails.transaction.placeholder": "Transaction ID",
	"DisputeDetails.transaction.provider": "Provider:",
	"DisputeDetails.transaction.providerStatus": "Provider status:",
	"DisputeDetails.value.no": "No",
	"DisputeDetails.value.yes": "Yes",
	"DisputeFilters.btn.filter": "Filter",
	"DisputeFilters.btn.reset": "Reset",
	"DisputeFilters.title.status": "Status",
	"Disputes.stats.title": "Statistics",
	"Disputes.title": "Disputes",
	"DisputesList.attachment": "Attachment",
	"DisputesList.empty": "No disputes found",
	"DisputesList.table.chat": "Chat / Sender",
	"DisputesList.table.date": "Date",
	"DisputesList.table.id": "ID",
	"DisputesList.table.merchant": "Merchant",
	"DisputesList.table.message": "Message",
	"DisputesList.table.status": "Status",
	"DisputesList.table.transaction": "Transaction",
	"Empty.message.dataSoon": "Data will appear soon",
	"EmptyChart.message": "Not enough data to build the chart",
	"EventsWidget.btn.createTicket": "Open a ticket",
	"EventsWidget.empty.message": "Important notifications will appear here",
	"EventsWidget.title": "Events",
	"FieldsHelper.error.charactersEmail": "The email address can only contain Latin letters, numbers, and the symbols «_.@». For example: john_doe@email.ru",
	"FieldsHelper.error.checkAmount": "Something's wrong with the amount. Please make sure you've typed it correctly. For example: 100.20",
	"FieldsHelper.error.checkBirthPlace": "Something's wrong with the place of birth. Please check and try again. For example: LYTKARINO",
	"FieldsHelper.error.checkCardNumber": "You entered the number incorrectly. Check it and try again",
	"FieldsHelper.error.checkCardholderName": "Something's wrong with the cardholder name. Please make sure you've typed it correctly. For example: JOHN DOE",
	"FieldsHelper.error.checkEmail": "Something's wrong with the address. Please make sure you've typed it correctly. For example: john_doe@email.ru",
	"FieldsHelper.error.checkIpSymbols": "Something's wrong with the IP address. Please check and try again. For example: 192.168.0.1",
	"FieldsHelper.error.checkIssued": "You entered the data incorrectly. Please check the field and try again",
	"FieldsHelper.error.checkLatinUsername": "Something's wrong with the account name. Please make sure you've typed it correctly. For example: john777",
	"FieldsHelper.error.checkNumbersInn": "Something's wrong with the INN. Please make sure you've typed it correctly. For example: 773334101234",
	"FieldsHelper.error.checkOTPCode": "Something's wrong with the one-time password. Please check and try again. For example: HS38ET",
	"FieldsHelper.error.checkPhone": "Something's wrong with the phone number. Please make sure you've typed it correctly. For example: +79854356633",
	"FieldsHelper.error.checkRegisterName": "Something's wrong with the registry name. Please check and try again. For example: Payouts for May",
	"FieldsHelper.error.checkUrlWebsite": "Something's wrong with the website URL. Please make sure you've typed it correctly. For example: https://yandex.ru",
	"FieldsHelper.error.docIssuerCode": "Specify department code",
	"FieldsHelper.error.docNumber": "Specify document number",
	"FieldsHelper.error.docSerial": "Specify document series",
	"FieldsHelper.error.onlyCyrLatinRegisterName": "The name can consist of letters from the Latin and Cyrillic alphabets, numbers, and symbols «_().». For example: Payouts for May",
	"FieldsHelper.error.onlyIpSymbols": "IP address can consist only of digits and separating dots. For example: 192.168.0.1",
	"FieldsHelper.error.onlyLatinBirthPlace": "Place of birth can contain only Latin letters and symbols «.»",
	"FieldsHelper.error.onlyLatinCardholder": "The cardholder name can only contain letters of the Latin alphabet. For example: JOHN DOE",
	"FieldsHelper.error.onlyLatinIssued": "Can contain only Latin letters and symbols «.\"». For example: DEPARTMENT OF THE FEDERAL MIGRATION SERVICE OF RUSSIA IN MOSCOW",
	"FieldsHelper.error.onlyLatinUsername": "The account name can contain only Latin letters and numbers. For example: john777",
	"FieldsHelper.error.onlyLettersAddress": "Address of birth can contain only Latin letters, digits, and symbols «.,/»",
	"FieldsHelper.error.onlyLettersFirstName": "The first name starts with a capital letter and consists of the Russian or Latin alphabet. For example: John",
	"FieldsHelper.error.onlyLettersLastName": "The last name starts with a capital letter and consists of the Russian or Latin alphabet. For example: Doe",
	"FieldsHelper.error.onlyLettersMetalType": "Metal type must consist of letters only",
	"FieldsHelper.error.onlyLettersNumbersOTPCode": "One-time password can contain only Latin letters and numbers. For example: HS38ET",
	"FieldsHelper.error.onlyLettersPatronymic": "The patronymic starts with a capital letter and consists of the Russian or Latin alphabet. For example: John",
	"FieldsHelper.error.onlyLettersProjectName": "The project name consists of the Russian or Latin alphabet, numbers, and symbols «.\"». For example: Google inc.",
	"FieldsHelper.error.onlyNumbersAmount": "The amount contains only digits and a «.» symbol. For example: 100.20",
	"FieldsHelper.error.onlyNumbersInn": "The INN can contain only numbers. For example: 773334101234",
	"FieldsHelper.error.onlyNumbersMetalImpurity": "Impurity must consist of numbers only",
	"FieldsHelper.error.onlyNumbersMetalPrice": "Price must consist of numbers only",
	"FieldsHelper.error.onlyNumbersMetalWeight": "Weight must consist of numbers only",
	"FieldsHelper.error.onlyNumbersPhone": "Phone number contains only digits and the «+» symbol. For example: +79854356633",
	"FieldsHelper.error.onlyUrlWebsite": "The website URL consists of the Latin alphabet, numbers, and symbols «/.:». For example: https://yandex.ru",
	"FieldsHelper.label.ContractName": "Contract name",
	"FieldsHelper.label.IPAccessRestriction": "IP Access Restriction",
	"FieldsHelper.label.Issued": "Issued by",
	"FieldsHelper.label.PcaName": "PSA name",
	"FieldsHelper.label.PcaTypeMetal": "Type of metal",
	"FieldsHelper.label.amount": "Amount",
	"FieldsHelper.label.authentication": "Two-factor authentication",
	"FieldsHelper.label.authenticationSelect": "Select type",
	"FieldsHelper.label.birthCountry": "Country of birth",
	"FieldsHelper.label.birthPlace": "Place of birth",
	"FieldsHelper.label.cardholder": "Cardholder name",
	"FieldsHelper.label.codeWord": "Code word",
	"FieldsHelper.label.contract": "Contract",
	"FieldsHelper.label.contractBtn": "Create",
	"FieldsHelper.label.contractBtnCreatePdf": "Download consent for personal data processing",
	"FieldsHelper.label.contractCreate": "New contract",
	"FieldsHelper.label.contractDelete": "Delete contract",
	"FieldsHelper.label.contractEdit": "Edit contract",
	"FieldsHelper.label.contractSave": "Save",
	"FieldsHelper.label.contractsList": "List of all contracts",
	"FieldsHelper.label.departmentCode": "Department code",
	"FieldsHelper.label.description": "Description",
	"FieldsHelper.label.docNumber": "Document number",
	"FieldsHelper.label.docSerial": "Document series",
	"FieldsHelper.label.email": "Email",
	"FieldsHelper.label.firstName": "First name",
	"FieldsHelper.label.gender": "Gender",
	"FieldsHelper.label.inn": "INN",
	"FieldsHelper.label.kpp": "KPP (Tax registration reason code)",
	"FieldsHelper.label.lastName": "Last name",
	"FieldsHelper.label.legalAddress": "Registration address",
	"FieldsHelper.label.legalName": "Legal entity name",
	"FieldsHelper.label.metalGrossWeight": "Gross weight (tons)",
	"FieldsHelper.label.metalImpurity": "Impurity (%)",
	"FieldsHelper.label.metalPrice": "Price (RUB)",
	"FieldsHelper.label.metalTareWeight": "Tare weight (tons)",
	"FieldsHelper.label.metalType": "Type",
	"FieldsHelper.label.metalWeight": "Weight (tons)",
	"FieldsHelper.label.ogrn": "OGRN (Primary State Registration Number)",
	"FieldsHelper.label.otpCode": "Code",
	"FieldsHelper.label.password": "Password",
	"FieldsHelper.label.patronymic": "Patronymic",
	"FieldsHelper.label.pca": "PSA",
	"FieldsHelper.label.pcaBtn": "Save and pay",
	"FieldsHelper.label.pcaBtnEdit": "Save changes",
	"FieldsHelper.label.pcaComment": "Comment for PSA",
	"FieldsHelper.label.pcaCreate": "Create PSA",
	"FieldsHelper.label.pcaDelete": "Delete PSA",
	"FieldsHelper.label.pcaDescription": "Description of items",
	"FieldsHelper.label.pcaDescriptionMetal": "Description of scrap and waste",
	"FieldsHelper.label.pcaDownload": "Download .xlsx",
	"FieldsHelper.label.pcaEdit": "View PSA",
	"FieldsHelper.label.pcaList": "List of all PSAs",
	"FieldsHelper.label.pcaSourceMetal": "Source of scrap",
	"FieldsHelper.label.pcaTransportMetal": "Vehicle make and number",
	"FieldsHelper.label.phone": "Phone",
	"FieldsHelper.label.processing": "Processing",
	"FieldsHelper.label.project": "Project",
	"FieldsHelper.label.projectName": "Project name",
	"FieldsHelper.label.projects": "Projects",
	"FieldsHelper.label.registryName": "Name",
	"FieldsHelper.label.residenceAddress": "Actual residence address",
	"FieldsHelper.label.selectProcessing": "Select processing",
	"FieldsHelper.label.selectProject": "Select project",
	"FieldsHelper.label.selectTerminal": "Select terminal",
	"FieldsHelper.label.terminal": "Terminal",
	"FieldsHelper.label.username": "Account name",
	"FieldsHelper.label.websiteUrl": "Website URL",
	"FieldsHelper.password.generate": "Generate password",
	"FieldsHelper.placeholder.birthCountry": "Select country",
	"FieldsHelper.placeholder.gender": "Select gender",
	"HeaderMenu.list.account": "My account",
	"HeaderMenu.list.admin": "Admin panel",
	"HeaderMenu.list.adminPanel": "Admin panel",
	"HeaderMenu.list.apiconsole": "Api console",
	"HeaderMenu.list.clientHome": "Home",
	"HeaderMenu.list.closeMenu": "Close menu",
	"HeaderMenu.list.logout": "Logout",
	"HeaderMenu.list.openMenu": "Open menu",
	"HeaderMenu.list.profile": "Profile",
	"HeaderMenu.list.secretChats": "Chats",
	"HeaderMenu.list.support": "Support",
	"LanguageSelect.language.en": "English",
	"LanguageSelect.language.ru": "Russian",
	"LoginForm.btn.continue": "Continue",
	"LoginForm.btn.login": "Login",
	"LoginForm.btn.sendAgain": "Send again",
	"LoginForm.error.codeInvalid": "Invalid confirmation code.",
	"LoginForm.error.codeRequired": "Confirmation code is required.",
	"LoginForm.error.credentials": "Invalid email or password.",
	"LoginForm.error.blocked": "Your account is blocked. Please contact support.",
	"LoginForm.error.empty": "Email and password are required.",
	"LoginForm.label.remember": "Remember me",
	"LoginForm.link.cantLogin": "Can't log in?",
	"LoginForm.link.forgotPassword": "Forgot password?",
	"LoginForm.logo.alt": "Logo",
	"LoginForm.modal.cantLogin.alt.clearSiteData": "Clearing site data",
	"LoginForm.modal.cantLogin.step.clearCache": "Clear the page cache (Ctrl + F5)",
	"LoginForm.modal.cantLogin.step.clearSiteData": "Clear site data in the browser",
	"LoginForm.modal.cantLogin.step.contactSupport": "Contact support:",
	"LoginForm.modal.cantLogin.title": "Can't log in?",
	"LoginForm.modal.close": "Close modal",
	"LoginForm.modal.forgotPassword.btn.sendCode": "Send code",
	"LoginForm.modal.forgotPassword.btn.verifyCode": "Confirm code",
	"LoginForm.modal.forgotPassword.placeholder.code": "Code from email",
	"LoginForm.modal.forgotPassword.placeholder.email": "Email",
	"LoginForm.modal.forgotPassword.title": "Reset password",
	"LoginForm.placeholder.code": "Code",
	"LoginForm.placeholder.email": "Login",
	"LoginForm.placeholder.password": "Password",
	"LoginForm.recovery.error.codeRequired": "Enter code",
	"LoginForm.recovery.error.emailRequired": "Enter email",
	"LoginForm.recovery.error.invalidCode": "Invalid code",
	"LoginForm.recovery.error.sendCode": "Failed to send code",
	"LoginForm.recovery.error.verifyCode": "Code verification failed",
	"LoginForm.recovery.success.codeSent": "If the account exists, the code has been sent by email",
	"LoginForm.recovery.success.passwordSent": "A new password has been sent by email",
	"LoginForm.text.codeExpired": "The verification code has expired.",
	"LoginForm.text.codeValid": "Code is valid for another {seconds} seconds",
	"LoginForm.text.mfaEmailMessage": "Enter the confirmation code from the {type} message sent to {email}",
	"LoginForm.text.mfaGAuthMessage": "Enter the confirmation code from Google Authenticator",
	"LoginForm.text.mfaPhoneMessage": "Enter the confirmation code from the {type} message sent to phone number {phone}",
	"LoginForm.title.login": "Login to your account",
	"MobileRegistry.table.amount": "Amount",
	"MobileRegistry.table.bic": "BIC / Bank ID",
	"MobileRegistry.table.cardHolderRu": "Full name",
	"MobileRegistry.table.documentDate": "Doc. date",
	"MobileRegistry.table.documentNumber": "Doc. number",
	"MobileRegistry.table.phone": "Phone",
	"MobileRegistry.upload.hint": "Drag and drop a registry (phone/SBP) here or use the {link}",
	"Modal.cancel": "Cancel",
	"Modal.confirm": "Confirm",
	"Pay.error.checkBic": "Enter a valid BIC (7-9 digits)",
	"Pay.error.checkBicOrMemberId": "Enter BIC (7-9 digits) or SBP bank ID",
	"Pay.error.checkFio": "Enter recipient full name",
	"Pay.error.checkPhoneFormat": "Enter a valid phone number (10-15 digits)",
	"Pay.error.documentDateFormat": "Enter date in YYYY-MM-DD format",
	"Pay.error.documentNumberRequired": "Enter contract number",
	"Pay.error.onlyNumbersBic": "Numbers only",
	"Pay.label.amount": "Transaction amount",
	"Pay.label.bankMemberId": "Recipient bank (SBP)",
	"Pay.label.bic": "Recipient bank BIC",
	"Pay.label.bicOrMemberId": "BIC or bank ID (SBP)",
	"Pay.label.documentDate": "Contract date",
	"Pay.label.documentNumber": "Contract number",
	"Pay.label.finstarData": "Contract data",
	"Pay.label.mobileRecipient": "Recipient (SBP)",
	"Pay.label.receiverCheck": "Receiver of check",
	"Pay.label.recipientFio": "Full name (Last First Middle)",
	"Pay.label.recipientName": "Recipient name",
	"Pay.label.recipientPhone": "Recipient phone number",
	"Pay.label.transferRecipient": "Transfer recipient",
	"Pay.title.oneTimePayment": "One-time payment",
	"Pay.toggle.card": "To card",
	"Pay.toggle.mobile": "By phone (SBP)",
	"PayControls.btn.send": "Send transfer",
	"PayControls.label.amount": "Amount:",
	"PayControls.label.balance": "Balance:",
	"PayControls.label.card": "Transfer to card:",
	"PayControls.label.commission": "Commission:",
	"PayControls.label.email": "Email:",
	"PayControls.label.holder": "Cardholder:",
	"PayControls.label.phone": "Phone:",
	"PayControls.title": "Payout details",
	"Payouts.title": "Projects",
	"PayoutsDetail.btn.retryFailed": "Retry failed",
	"PayoutsDetail.modal.amount": "Amount",
	"PayoutsDetail.modal.card": "Card",
	"PayoutsDetail.modal.moreItems": "... and {count} more",
	"PayoutsDetail.modal.pendingListTitle": "Matching pending transactions:",
	"PayoutsDetail.modal.pendingWarning": "Cards from the uploaded registry are already being processed. Possible duplicate payouts.",
	"PayoutsDetail.modal.recipient": "Recipient",
	"PayoutsDetail.modal.warningTitle": "Warning",
	"PayoutsDetailAmounts.label.failed": "Unpaid amount:",
	"PayoutsDetailAmounts.label.other": "Deferred amount:",
	"PayoutsDetailAmounts.label.success": "Paid amount:",
	"PayoutsDetailEditing.btn.save": "Save",
	"PayoutsDetailEditing.error.emptyName": "Registry name cannot be empty.",
	"PayoutsDetailEditing.error.generic": "Oops! Something went wrong. Wait a bit and try again.",
	"PayoutsDetailEditing.error.network": "Oops! Something went wrong. Refresh the page and try again.",
	"PayoutsDetailEditing.label.tags": "Tags",
	"PayoutsDetailEditing.placeholder.name": "Name cannot be empty",
	"PayoutsDetailEditing.success.saved": "Success! Data saved.",
	"PayoutsDetailEditing.title": "Registry editing",
	"PayoutsDetailFilters.btn.setFilters": "Apply filters",
	"PayoutsDetailFilters.status.delayed": "Deferred",
	"PayoutsDetailFilters.status.error": "Error",
	"PayoutsDetailFilters.status.filtered": "Filtered",
	"PayoutsDetailFilters.status.paid": "Paid",
	"PayoutsDetailFilters.title.status": "Status",
	"PayoutsDetailTags.noSuggestions": "No tags found",
	"PayoutsDetailTags.placeholder": "Add tag",
	"PayoutsFilters.btn.filter": "Filter",
	"PayoutsFilters.status.created": "Created",
	"PayoutsFilters.status.delayed": "Delayed",
	"PayoutsFilters.status.inProgress": "In progress",
	"PayoutsFilters.status.processed": "Processed",
	"PayoutsFilters.status.processedWithErrors": "Processed with errors",
	"PayoutsFilters.title.status": "Status",
	"PayoutsFilters.title.tags": "Tags",
	"PayoutsTable.empty": "No data matching filters",
	"PayoutsTable.status.created": "Aside",
	"PayoutsTable.status.filtered": "Filtered",
	"PayoutsTable.status.payout": "Payout",
	"PayoutsTable.status.payoutDecline": "Error",
	"PayoutsTable.tab.bank": "Card bank:",
	"PayoutsTable.tab.country": "Card country:",
	"PayoutsTable.tab.created": "Created:",
	"PayoutsTable.tab.extStatus": "Extended status:",
	"PayoutsTable.tab.fee": "Commission:",
	"PayoutsTable.tab.id": "Transaction ID:",
	"PayoutsTable.tab.params": "Payout parameters",
	"PayoutsTable.tab.processed": "Processed:",
	"PayoutsTable.tab.reason": "Error reason:",
	"PayoutsTable.tab.system": "Payment system:",
	"PayoutsTable.table.amount": "Amount",
	"PayoutsTable.table.pan": "PAN",
	"PayoutsTable.table.phone": "Phone",
	"PayoutsTable.table.recipient": "Recipient",
	"PayoutsTable.table.status": "Status",
	"PcaFilters.status.error": "Error / Payment declined",
	"PcaFilters.status.inProgress": "In progress",
	"PcaFilters.status.inactive": "Inactive",
	"PcaFilters.status.processed": "Paid",
	"PcaFilters.title.status": "Status",
	"PcaTable.empty": "No PSA",
	"PcaTable.menu.duplicate": "Duplicate PSA",
	"PcaTable.menu.view": "View PSA",
	"PcaTable.status.declined": "Payment declined",
	"PcaTable.status.error": "Error",
	"PcaTable.status.inProgress": "In progress",
	"PcaTable.status.inactive": "Inactive",
	"PcaTable.status.paid": "Paid",
	"PcaTable.table.amount": "Amount",
	"PcaTable.table.contract": "Contract",
	"PcaTable.table.date": "PSA date",
	"PcaTable.table.id": "ID",
	"PcaTable.table.name": "PSA name",
	"PcaTable.table.provider": "Provider",
	"PcaTable.table.status": "Status",
	"PersonalManager.description": "For all service-related questions, please contact your personal manager:",
	"PersonalManager.phone.mobile": "Mobile",
	"PersonalManager.phone.work": "Work",
	"PersonalManager.title": "Personal Manager",
	"Prepaid.title": "Prepaid Cards",
	"Prepaid.title.activate": "Card activation",
	"Prepaid.title.details": "Card details",
	"PrepaidDetails.button.activate": "Activate",
	"PrepaidDetails.gender.female": "Female",
	"PrepaidDetails.gender.male": "Male",
	"PrepaidDetails.label.birthCountry": "Country of Birth:",
	"PrepaidDetails.label.birthPlace": "Place of Birth:",
	"PrepaidDetails.label.birthday": "Date of Birth:",
	"PrepaidDetails.label.docIssuedDate": "Issue Date:",
	"PrepaidDetails.label.docIssuer": "Issued By:",
	"PrepaidDetails.label.docIssuerCode": "Department Code:",
	"PrepaidDetails.label.docNumber": "Document Number:",
	"PrepaidDetails.label.docSerial": "Document Series:",
	"PrepaidDetails.label.firstName": "First Name:",
	"PrepaidDetails.label.gender": "Gender:",
	"PrepaidDetails.label.lastName": "Last Name:",
	"PrepaidDetails.label.legalAddress": "Registered Address:",
	"PrepaidDetails.label.patronymic": "Patronymic:",
	"PrepaidDetails.label.phone": "Phone:",
	"PrepaidDetails.label.residenceAddress": "Actual Residence Address:",
	"PrepaidDetails.subtitle.ean": "EAN: {ean} ({part})",
	"PrepaidDetails.tab.contacts": "Contact Information",
	"PrepaidDetails.tab.passport": "Passport Data",
	"PrepaidDetails.tab.personal": "Personal Data",
	"PrepaidTable.empty": "No prepaid cards",
	"PrepaidTable.menu.activate": "Activate",
	"PrepaidTable.menu.details": "Details",
	"PrepaidTable.status.active": "Active",
	"PrepaidTable.status.error": "Error",
	"PrepaidTable.status.inactive": "Inactive",
	"PrepaidTable.status.processing": "Processing",
	"PrepaidTable.table.card": "Card",
	"PrepaidTable.table.client": "Client",
	"PrepaidTable.table.ean": "EAN",
	"PrepaidTable.table.project": "Project",
	"PrepaidTable.table.status": "Status",
	"Profile.btn.activate": "Activate",
	"Profile.btn.connectOTP": "Connect",
	"Profile.btn.save": "Save changes",
	"Profile.button.changePassword": "Change password",
	"Profile.button.save": "Save changes",
	"Profile.error.emailConfirmationNotSent": "Could not send an email to {email}. Your address is unchanged — try again later or contact support.",
	"Profile.error.save": "Error. There are errors in the form. Check the data and try again.",
	"Profile.label.email": "Email",
	"Profile.label.firstName": "First name",
	"Profile.label.lastName": "Last name",
	"Profile.label.password": "Password",
	"Profile.label.patronymic": "Patronymic",
	"Profile.link.cancel": "Cancel changes",
	"Profile.modal.title": "Change data",
	"Profile.section.password": "Change password",
	"Profile.section.personal": "Personal data",
	"Profile.success.emailConfirmationPending": "We sent an email to {email}. The address will change after you follow the link in it.",
	"Profile.success.save": "Success. You have successfully saved the form.",
	"Profile.text.changeEmail": "The account email address has been changed. After confirmation, a letter with further instructions will be sent to {email}.",
	"Profile.text.changeIpAccessList": "The list of allowed IP addresses has been changed. After confirmation, the personal cabinet will be accessible only from addresses: {ipAccessList}.",
	"Profile.text.changeIpAccessListClean": "The list of allowed IP addresses has been changed. After confirmation, the personal cabinet will be accessible from all addresses without restrictions.",
	"Profile.text.changeOTPEmail": "To confirm the operation, enter the one-time password sent to the email address {email}. If the email is not in the \"Inbox\" folder, check the \"Spam\" folder.",
	"Profile.text.changeOTPGAuth": "To confirm the operation, enter the one-time password generated in the Google Authenticator app.",
	"Profile.text.changeOTPPhone": "To confirm the operation, enter the one-time password sent in an SMS message to the number {phone}.",
	"Profile.text.changePassword": "The account password has been changed. After confirmation, you will be logged out on all devices. Before confirming, write down and save the new password in a safe place: {password}",
	"Profile.text.logout": "After changing password, you will be logged out on all devices.",
	"Profile.text.support": "To change full name, contact support.",
	"Profile.title.myProfile": "My profile",
	"Profile.warning.requires2FASetup": "To continue, you need to set up two-factor authentication",
	"ProjectAdd.btn.add": "Add project",
	"ProjectAdd.btn.saving": "Saving...",
	"ProjectAdd.error.create": "Error creating project. {errors}",
	"ProjectAdd.success.created": "Project created",
	"ProjectEditing.antifraud.title": "Antifraud",
	"ProjectEditing.button.deleteService": "Delete service",
	"ProjectEditing.button.refresh": "Refresh from API",
	"ProjectEditing.button.reset": "Reset changes",
	"ProjectEditing.button.save": "Save",
	"ProjectEditing.empty": "Project not selected",
	"ProjectEditing.error.load": "Failed to load full merchant data",
	"ProjectEditing.error.refresh": "Failed to refresh data",
	"ProjectEditing.error.save": "Failed to save changes",
	"ProjectEditing.fees.fixed": "Fixed",
	"ProjectEditing.fees.percent": "%",
	"ProjectEditing.fees.type": "Type",
	"ProjectEditing.field.auth": "Authorization data",
	"ProjectEditing.field.description": "Description",
	"ProjectEditing.field.fees": "Fees",
	"ProjectEditing.field.inn": "INN",
	"ProjectEditing.field.kpp": "KPP",
	"ProjectEditing.field.login": "Login",
	"ProjectEditing.field.name": "Name",
	"ProjectEditing.field.ogrn": "OGRN",
	"ProjectEditing.field.provider": "Provider",
	"ProjectEditing.field.secret": "Secret / API Key",
	"ProjectEditing.field.url": "Website",
	"ProjectEditing.loading": "Loading...",
	"ProjectEditing.merchantKey.hint": "This key is used by the merchant for signing/authenticating requests.",
	"ProjectEditing.merchantKey.title": "Merchant key",
	"ProjectEditing.mid.balance": "Balance:",
	"ProjectEditing.mid.currency": "Currency:",
	"ProjectEditing.mid.currencyBalance": "Currency and balance:",
	"ProjectEditing.mid.currentProvider": "Current provider:",
	"ProjectEditing.mid.delete": "Delete",
	"ProjectEditing.mid.fee.add": "Add fee",
	"ProjectEditing.mid.fee.fixed": "Fixed:",
	"ProjectEditing.mid.fee.minFixed": "Min. fixed:",
	"ProjectEditing.mid.fee.payment": "Payment",
	"ProjectEditing.mid.fee.payout": "Payout",
	"ProjectEditing.mid.fee.percent": "%:",
	"ProjectEditing.mid.fees": "Fees:",
	"ProjectEditing.mid.methods": "Available methods:",
	"ProjectEditing.mid.new": "new",
	"ProjectEditing.mid.openTerminal": "Open terminal settings",
	"ProjectEditing.mid.provider": "Provider:",
	"ProjectEditing.mid.terminalNotLinked": "Terminal not linked",
	"ProjectEditing.mid.title": "MID #{id}",
	"ProjectEditing.mid.widget": "Widget settings:",
	"ProjectEditing.modal.terminalSettings": "Terminal settings",
	"ProjectEditing.modal.userPermissions": "User permissions {username}",
	"ProjectEditing.noData": "No data",
	"ProjectEditing.section.services": "Services (MID)",
	"ProjectEditing.settings.add": "+ Add setting (MID)",
	"ProjectEditing.settings.empty": "No settings found",
	"ProjectEditing.settings.refresh": "Refresh from API",
	"ProjectEditing.settings.title": "Merchant settings (MID)",
	"ProjectEditing.success.allSaved": "All changes saved",
	"ProjectEditing.title": "Project",
	"ProjectEditing.users.title": "Project users",
	"ProjectEditing.widget.callback": "Callback URL",
	"ProjectEditing.widget.callbackHint": "URL for sending callbacks from the widget",
	"ProjectEditing.widget.generate": "Generate",
	"ProjectEditing.widget.key": "Widget key",
	"ProjectEditing.widget.keyHint": "Key for widget authorization",
	"ProjectSearchList.empty": "Nothing found",
	"ProjectSearchList.permissions.btn": "Permissions",
	"ProjectSearchList.permissions.title": "Configure permissions",
	"ProjectSearchList.placeholder": "Search project by name or UUID...",
	"ProjectSearchList.remove.aria": "Remove {name}",
	"ProjectSearchList.selected.title": "Selected projects",
	"ProjectSettings.button.save": "Save",
	"ProjectSettings.checkbox.hideCardholder": "Hide \"Cardholder name\" field",
	"ProjectSettings.checkbox.hideReceipt": "Hide \"Get receipt\" field",
	"ProjectSettings.checkbox.uniqueCheck": "Enable uniqueness check",
	"ProjectSettings.general.description": "Project Description",
	"ProjectSettings.general.id": "Project ID",
	"ProjectSettings.general.info.title": "General Information",
	"ProjectSettings.general.inn": "TIN",
	"ProjectSettings.general.name": "Project Name",
	"ProjectSettings.general.site": "Website",
	"ProjectSettings.general.technical": "Technical",
	"ProjectSettings.info.type": "Settlement organization",
	"ProjectSettings.paymentForm.title": "Payment form settings",
	"ProjectSettings.status.active": "Active",
	"ProjectSettings.status.blocked": "Blocked",
	"ProjectSettings.tab.general": "General Settings",
	"ProjectSettings.tab.paymentForm": "Payment Form",
	"ProjectSettings.tab.terminals": "Terminals",
	"ProjectSettings.terminals.title": "List of terminals",
	"Projects.button.add": "Add",
	"Projects.modal.addTitle": "Add new project",
	"ProjectsControl.title.projects": "Projects",
	"ProjectsFilters.btn.filter": "Filter",
	"ProjectsFilters.status.active": "Active",
	"ProjectsFilters.status.blocked": "Blocked",
	"ProjectsFilters.status.inactive": "Inactive",
	"ProjectsFilters.title.status": "Status",
	"ProjectsList.empty": "No accounts found",
	"ProjectsList.table.accounts": "Accounts",
	"ProjectsList.table.createdAt": "Created",
	"ProjectsList.table.name": "Name",
	"ProjectsList.table.status": "Status",
	"ProjectsList.table.website": "Website",
	"ProjectsTable.link.payouts": "Payouts",
	"ProjectsTable.link.settings": "Settings",
	"ProjectsTable.status.active": "Active",
	"ProjectsTable.status.blocked": "Blocked",
	"ProjectsTable.table.actualBalance": "Actual",
	"ProjectsTable.table.balance": "Balance",
	"ProjectsTable.table.project": "Project",
	"ProjectsTable.table.reservedBalance": "Reserved",
	"ProjectsTable.table.settlementBalance": "Settlement",
	"ProjectsTable.table.site": "Site",
	"ProjectsTable.table.status": "Status",
	"ProjectsTable.table.transactionBalance": "Transaction",
	"ProjectsWidget.empty.title": "No active projects",
	"ProjectsWidget.error.load": "Failed to load projects",
	"ProjectsWidget.help.avgBill": "Average bill",
	"ProjectsWidget.link.viewAll": "View all",
	"ProjectsWidget.table.balance": "Balance",
	"ProjectsWidget.table.payments": "Payments",
	"ProjectsWidget.table.payouts": "Payouts",
	"ProjectsWidget.table.project": "Project",
	"ProjectsWidget.table.settings": "Settings",
	"ProjectsWidget.table.website": "Website",
	"ProjectsWidget.title": "Projects",
	"RefillsFilters.btn.setFilters": "Apply filters",
	"RefillsFilters.status.crediting": "Crediting",
	"RefillsFilters.status.writeOff": "Write-off",
	"RefillsFilters.title.status": "Status",
	"RefillsTable.empty": "No transactions",
	"RefillsTable.table.amount": "Amount",
	"RefillsTable.table.date": "Date",
	"RefillsTable.table.project": "Project",
	"RefillsTable.type.crediting": "Crediting",
	"RefillsTable.type.writeOff": "Write-off",
	"RegistryControls.btn.clear": "Clear",
	"RegistryControls.checkbox.showErrors": "Show errors",
	"RegistryControls.tags.label": "Add tags",
	"RegistryControls.tags.placeholder": "Add tags to registry",
	"RegistryControls.title": "Registry management",
	"RegistryDADUpload.error.format": "(code: {code}) Error! Registry format is invalid. Fix errors and try again.",
	"RegistryDADUpload.error.network": "Upload failed. Try again.",
	"RegistryDADUpload.hint": "Drag and drop registry here or click to select",
	"RegistryDADUpload.link": "link",
	"RegistryDADUpload.loading": "Processing...",
	"RegistryList.confirm.reprocess": "Reprocess registry \"{name}\"?",
	"RegistryList.empty": "No registries found",
	"RegistryList.menu.downloadRegistry": "Download registry",
	"RegistryList.menu.report": "Export report",
	"RegistryList.menu.reprocess": "Reprocess",
	"RegistryList.menu.view": "View details",
	"RegistryList.status.created": "Created",
	"RegistryList.status.delayed": "Delayed",
	"RegistryList.status.inProcessing": "In processing",
	"RegistryList.status.processed": "Processed",
	"RegistryList.status.processedWithErrors": "Processed with errors",
	"RegistryList.status.reprocess": "Reprocess",
	"RegistryList.table.amount": "Amount",
	"RegistryList.table.date": "Date",
	"RegistryList.table.fee": "Fee",
	"RegistryList.table.id": "ID",
	"RegistryList.table.merchant": "Merchant",
	"RegistryList.table.status": "Status",
	"RegistryList.table.tags": "Tags",
	"RegistryUpload.btn.sendRegistry": "Upload registry",
	"RegistryUpload.error.field": "Field",
	"RegistryUpload.error.message": "Message",
	"RegistryUpload.error.value": "Value",
	"RegistryUpload.match.data": "Data",
	"RegistryUpload.match.name": "Name",
	"RegistryUpload.modal.duplicateConfirm": "Are you sure you want to continue?",
	"RegistryUpload.modal.duplicateTitle": "Possible duplicate detected",
	"RegistryUpload.modal.duplicateWarning": "Similar registries were found in the last 30 days:",
	"RegistryUpload.table.amount": "Amount",
	"RegistryUpload.table.cardHolderRu": "Cardholder name",
	"RegistryUpload.table.creditCard": "Card number",
	"RegistryUpload.table.phoneNumber": "Phone",
	"RegistryUploadInfo.errors.format": "File format error",
	"RegistryUploadInfo.errors.missingColumn": "Required column missing: {column}",
	"RegistryUploadInfo.table.amount": "Amount:",
	"RegistryUploadInfo.table.balance": "Balance:",
	"RegistryUploadInfo.table.errors": "Errors:",
	"RegistryUploadInfo.table.fee": "Fee:",
	"RegistryUploadInfo.table.registry": "Registry:",
	"ReportConstructor.btn.createReport": "Create report",
	"ReportConstructor.label.format": "Format",
	"ReportConstructor.label.merchant": "Merchant",
	"ReportConstructor.label.minFee": "Min fee",
	"ReportConstructor.label.period": "Period",
	"ReportConstructor.label.providerFee": "Provider fee",
	"ReportConstructor.label.reportConstructor": "Report constructor",
	"ReportConstructor.label.reportType": "Report type",
	"ReportConstructor.label.selectMerchant": "Select merchant",
	"ReportConstructor.msg.error": "Error generating report",
	"ReportConstructor.msg.noData": "No data for report",
	"ReportConstructor.msg.selectMerchant": "Select a merchant",
	"ReportConstructor.msg.selectPeriod": "Select a period",
	"ReportConstructor.option.merchants": "By merchants",
	"ReportConstructor.option.transactions": "By transactions",
	"ReportConstructor.table.amount": "Top-up amount",
	"ReportConstructor.table.count": "Number of transactions",
	"ReportConstructor.table.fee": "Fee",
	"ReportConstructor.table.provider": "Provider",
	"ReportWidget.format": "Format:",
	"ReportWidget.generate": "Generate report {format}",
	"ReportWidget.imageAlt": "Generate report",
	"ReportWidget.operations": "Operations",
	"SbpPay.label.recipient": "Recipient (SBP)",
	"SbpPay.title": "SBP Payout",
	"Search.example.amount": "example: 10 000",
	"Search.example.amountLess": "example: 10 000",
	"Search.example.cardHolder": "example: Ivan Ivanov",
	"Search.example.cardNumber": "example: 777777 •••• 7777",
	"Search.example.description": "example: purchase operation",
	"Search.example.email": "example: support@email.io",
	"Search.example.externalReference": "example: c8c32d92-cd65-428d-9e2f-896923a3b864",
	"Search.example.fio": "example: John Doe",
	"Search.example.id": "example: 1288",
	"Search.example.pan": "example: 4111111111",
	"Search.example.phone": "74954453019",
	"Search.example.rrn": "___",
	"Search.label.accountId": "Account ID",
	"Search.label.amountEqually": "Amount equally",
	"Search.label.amountLess": "Amount less",
	"Search.label.amountMore": "Amount more",
	"Search.label.cardHolder": "Cardholder",
	"Search.label.cardNumber": "Card Number",
	"Search.label.currency": "Currency",
	"Search.label.description": "Description",
	"Search.label.email": "Email",
	"Search.label.externalReference": "External reference",
	"Search.label.fio": "User name",
	"Search.label.merchantName": "merchant name",
	"Search.label.messageText": "message text",
	"Search.label.operationId": "Transaction ID",
	"Search.label.pan": "PAN",
	"Search.label.phone": "Phone",
	"Search.label.projectName": "Project name",
	"Search.label.projectUuid": "Project UUID",
	"Search.label.providerName": "Provider",
	"Search.label.registryData": "Search by: ID, PAN, name, amount or phone",
	"Search.label.rrn": "RRN",
	"Search.label.searchBy": "Search by",
	"Search.label.senderName": "sender",
	"Search.label.terminalId": "Terminal ID",
	"Search.label.terminalName": "Terminal name",
	"Search.label.transactionId": "Transaction ID",
	"Search.label.url": "Website address",
	"Search.label.username": "Login",
	"Search.label.uuid": "Project UUID",
	"Search.placeholder.accountId": "Enter account ID",
	"Search.placeholder.currency": "Enter currency code",
	"Search.placeholder.description": "Enter project description",
	"Search.placeholder.email": "Enter email",
	"Search.placeholder.fio": "Enter full name",
	"Search.placeholder.merchantName": "Enter merchant name",
	"Search.placeholder.messageText": "Enter search text",
	"Search.placeholder.projectName": "Enter project name",
	"Search.placeholder.projectUuid": "Enter project UUID",
	"Search.placeholder.providerName": "Enter provider name",
	"Search.placeholder.senderName": "Enter sender name",
	"Search.placeholder.terminalId": "Enter terminal ID",
	"Search.placeholder.terminalName": "Enter terminal name",
	"Search.placeholder.transactionId": "Enter transaction ID",
	"Search.placeholder.url": "Enter project URL",
	"Search.placeholder.username": "Login",
	"Search.placeholder.uuid": "Enter project UUID",
	"SearchTags.add": "add",
	"SearchTags.find": "Find",
	"SearchTags.label": "Search by",
	"SearchTags.placeholder.phone": "+7 (___) ___-__-__",
	"SearchTags.search": "Search",
	"SecretChat.button.new": "New chat",
	"SecretChat.button.send": "Send",
	"SecretChat.day.today": "Today",
	"SecretChat.empty.messages": "Empty so far — write first",
	"SecretChat.empty.pick": "Pick a chat or start a new one",
	"SecretChat.error.download": "The file was not downloaded — it may already be deleted",
	"SecretChat.error.load": "Failed to load the conversation",
	"SecretChat.error.send": "Message was not sent",
	"SecretChat.file.attach": "Attach a file",
	"SecretChat.file.download": "Download the file",
	"SecretChat.left.hours": "disappears in {hours} h {minutes} min",
	"SecretChat.left.minutes": "disappears in {minutes} min",
	"SecretChat.list.title": "Conversations",
	"SecretChat.loading": "Loading…",
	"SecretChat.note.ttl": "Encrypted, deleted after {hours} h",
	"SecretChat.placeholder": "Message…",
	"SecretChats.admin.title": "Secret chats",
	"SecretChats.button.cancel": "Cancel",
	"SecretChats.button.clearClient": "Pick another",
	"SecretChats.button.create": "Start chat",
	"SecretChats.empty": "No chats yet",
	"SecretChats.error.create": "Failed to create the chat",
	"SecretChats.error.list": "Failed to load the chat list",
	"SecretChats.field.client": "Client: start typing a name or login",
	"SecretChats.field.first": "First message (optional)",
	"SecretChats.field.search": "Search client",
	"SecretChats.field.subject": "Conversation subject",
	"SecretChats.loading": "Loading…",
	"SecretChats.subtitle": "Messages are encrypted and fully deleted after {hours} hours",
	"SecretChats.title": "Secret chats",
	"Status.active": "Active",
	"Status.blocked": "Blocked",
	"Status.inactive": "Inactive",
	"Status.unknown": "Unknown",
	"Support.chat.button": "Support chat",
	"Support.general.title": "General questions",
	"Support.manager.title": "Your manager",
	"Support.tech.title": "Technical questions",
	"Support.ticket.create": "Open a ticket",
	"Support.ticket.title": "Need help?",
	"SupportWidget.action.attachFile": "Attach file",
	"SupportWidget.action.back": "Back",
	"SupportWidget.action.collapse": "Collapse",
	"SupportWidget.action.createTicket": "Create ticket",
	"SupportWidget.action.send": "Send",
	"SupportWidget.action.sending": "Sending...",
	"SupportWidget.attachment.purged": "file removed due to retention policy",
	"SupportWidget.closedNote": "This ticket is closed. Create a new one if you need help.",
	"SupportWidget.edit.cancel": "Cancel",
	"SupportWidget.edit.save": "Save",
	"SupportWidget.edit.title": "Edit",
	"SupportWidget.empty.chat": "Start the conversation and messages will appear here.",
	"SupportWidget.empty.listText": "Describe the issue, attach screenshots or documents, and we will reply as soon as possible.",
	"SupportWidget.empty.listTitle": "Ask support a question",
	"SupportWidget.error.bodyOrFileRequired": "Describe your issue or attach a file.",
	"SupportWidget.error.fileTooLarge": "File \"{name}\" is larger than 25 MB.",
	"SupportWidget.error.maxFiles": "No more than 10 files per message.",
	"SupportWidget.error.save": "Failed to save.",
	"SupportWidget.error.send": "Failed to send.",
	"SupportWidget.error.subjectRequired": "Enter a ticket subject.",
	"SupportWidget.header.listSubtitle": "We usually reply within an hour",
	"SupportWidget.header.listTitle": "Support",
	"SupportWidget.header.newSubtitle": "Describe your issue and we will help",
	"SupportWidget.header.newTitle": "New ticket",
	"SupportWidget.hint.attachments": "You can attach up to 10 files (up to 25 MB each): screenshots, documents, videos.",
	"SupportWidget.message.deleted": "message deleted",
	"SupportWidget.message.edited": "edited",
	"SupportWidget.placeholder.details": "Describe your issue in more detail...",
	"SupportWidget.placeholder.message": "Message...",
	"SupportWidget.placeholder.subject": "Ticket subject",
	"SupportWidget.size.bytes": "{count} B",
	"SupportWidget.size.kb": "{count} KB",
	"SupportWidget.size.mb": "{count} MB",
	"SupportWidget.status.closed": "Closed",
	"SupportWidget.status.open": "Open",
	"SupportWidget.status.pendingUser": "Waiting for response",
	"SupportWidget.time.daysAgo": "{count} d ago",
	"SupportWidget.time.hoursAgo": "{count} h ago",
	"SupportWidget.time.justNow": "just now",
	"SupportWidget.time.minutesAgo": "{count} min ago",
	"TerminalAdd.btn.create": "Create",
	"TerminalAdd.error.create": "Failed to create terminal",
	"TerminalAdd.error.missing": "Specify project and name",
	"TerminalAdd.label.name": "Name",
	"TerminalAdd.label.project": "Project",
	"TerminalAdd.label.provider": "Provider (optional)",
	"TerminalAdd.label.status": "Status",
	"TerminalAdd.placeholder.noProvider": "— do not select —",
	"TerminalAdd.placeholder.selectProject": "— select project —",
	"TerminalAdd.status.active": "Active",
	"TerminalAdd.status.inactive": "Inactive",
	"TerminalAdd.success.created": "Terminal created",
	"TerminalEditing.auth.empty": "No authorization keys",
	"TerminalEditing.button.save": "Save",
	"TerminalEditing.button.saveLimits": "Save limits",
	"TerminalEditing.empty": "No terminal selected",
	"TerminalEditing.error.loadLimits": "Error loading limits",
	"TerminalEditing.error.save": "Failed to save terminal",
	"TerminalEditing.error.saveLimits": "Error saving limits",
	"TerminalEditing.field.balance": "Balance",
	"TerminalEditing.field.bankAccount": "Bank account",
	"TerminalEditing.field.exchangeRate": "Exchange rate",
	"TerminalEditing.field.name": "Name",
	"TerminalEditing.field.paymentMethod": "Payment method",
	"TerminalEditing.field.returnUrl": "Return URL",
	"TerminalEditing.field.status": "Status",
	"TerminalEditing.field.webhookUrl": "Webhook URL",
	"TerminalEditing.limits.amount": "Amount",
	"TerminalEditing.limits.daily": "Day",
	"TerminalEditing.limits.max": "Max. amount",
	"TerminalEditing.limits.min": "Min. amount",
	"TerminalEditing.limits.monthly": "Month",
	"TerminalEditing.limits.payment.title": "Payments (payment)",
	"TerminalEditing.limits.payout.title": "Payouts (payout)",
	"TerminalEditing.limits.payoutLimit.title": "Total payout limit (payoutLimit)",
	"TerminalEditing.limits.perDay": "Per day",
	"TerminalEditing.limits.perHour": "Per hour",
	"TerminalEditing.limits.perMinute": "Per minute",
	"TerminalEditing.limits.velocity.title": "Velocity",
	"TerminalEditing.loading.limits": "Loading limits...",
	"TerminalEditing.method.h2h": "H2H",
	"TerminalEditing.method.partialRefund": "Partial refund",
	"TerminalEditing.method.partialReversal": "Partial reversal",
	"TerminalEditing.method.preAuth": "Pre-authorization",
	"TerminalEditing.method.recurring": "Recurring",
	"TerminalEditing.method.sbp": "SBP",
	"TerminalEditing.placeholder.notSet": "not set",
	"TerminalEditing.provider.current": "Current: {name}",
	"TerminalEditing.provider.noChange": "— do not change —",
	"TerminalEditing.save": "Save",
	"TerminalEditing.saving.limits": "Saving...",
	"TerminalEditing.section.auth": "Authorization data (processingAuth)",
	"TerminalEditing.section.limits": "Limits",
	"TerminalEditing.section.methods": "Methods",
	"TerminalEditing.section.other": "Other",
	"TerminalEditing.section.provider": "Provider binding",
	"TerminalEditing.status.active": "Active",
	"TerminalEditing.status.inactive": "Inactive",
	"TerminalEditing.success.limitsSaved": "Limits saved",
	"TerminalEditing.success.saved": "Terminal saved",
	"TerminalEditing.title": "Terminal",
	"Terminals.add": "Add",
	"Terminals.modal.addTitle": "Add terminal",
	"Terminals.title": "Terminals",
	"TerminalsFilters.btn.apply": "Apply",
	"TerminalsFilters.method.partialRefund": "Partial refund",
	"TerminalsFilters.method.partialReversal": "Partial reversal",
	"TerminalsFilters.method.preAuth": "Pre-authorization",
	"TerminalsFilters.method.recurring": "Recurring",
	"TerminalsFilters.method.sbp": "SBP",
	"TerminalsFilters.provider.any": "— any —",
	"TerminalsFilters.provider.label": "Provider",
	"TerminalsFilters.status.active": "Active",
	"TerminalsFilters.status.inactive": "Inactive",
	"TerminalsFilters.title": "Filters",
	"TerminalsList.currency": "Currency: {name}",
	"TerminalsList.empty": "Nothing found",
	"TerminalsList.method.p2p": "P2P",
	"TerminalsList.method.partialRefund": "Partial refund",
	"TerminalsList.method.partialReversal": "Partial reversal",
	"TerminalsList.method.preAuth": "Pre-auth",
	"TerminalsList.method.recurring": "Recurring",
	"TerminalsList.method.sbp": "SBP",
	"TerminalsList.status.active": "Active",
	"TerminalsList.status.inactive": "Inactive",
	"TerminalsList.table.balance": "Balance",
	"TerminalsList.table.id": "ID",
	"TerminalsList.table.methods": "Methods",
	"TerminalsList.table.project": "Project",
	"TerminalsList.table.provider": "Provider",
	"TerminalsList.table.status": "Status",
	"TerminalsList.table.terminal": "Terminal",
	"TerminalsTable.empty": "No connected terminals",
	"TerminalsTable.fee.fixed": "Transaction fee:",
	"TerminalsTable.fee.fixedValue": "fixed {value}",
	"TerminalsTable.fee.percent": "Transaction fee:",
	"TerminalsTable.fee.percentValue": "{percent}% (min {min}₽)",
	"TerminalsTable.status.active": "Active",
	"TerminalsTable.status.blocked": "Blocked",
	"TerminalsTable.tab.payments": "Payments",
	"TerminalsTable.tab.payouts": "Payouts",
	"TerminalsTable.table.confirmed": "Confirmed balance",
	"TerminalsTable.table.currency": "Currency",
	"TerminalsTable.table.holded": "Holded balance",
	"TerminalsTable.table.id": "ID",
	"TerminalsTable.table.mcc": "MCC",
	"TerminalsTable.table.name": "Name",
	"TerminalsTable.table.status": "Status",
	"TerminalsTable.table.turnover": "Turnover",
	"TicketsTable.empty": "You have no tickets",
	"TicketsTable.table.lastFrom": "Last message from",
	"TicketsTable.table.message": "Message",
	"TicketsTable.table.status": "Status",
	"TicketsTable.table.updated": "Updated",
	"TransactionAudit.amount": "Amount",
	"TransactionAudit.clearFilters": "Clear Filters",
	"TransactionAudit.createdAt": "Created",
	"TransactionAudit.direction": "Direction",
	"TransactionAudit.empty": "No audit data available",
	"TransactionAudit.error": "Error: {error}",
	"TransactionAudit.eventTypes": "Event Types",
	"TransactionAudit.externalRef": "External Ref",
	"TransactionAudit.filters": "Filters",
	"TransactionAudit.fraud.blocked": "Blocked by antifraud",
	"TransactionAudit.fraud.ok": "Antifraud: OK",
	"TransactionAudit.hint": "Enter a transaction ID to view its complete audit history",
	"TransactionAudit.loading": "Loading audit data...",
	"TransactionAudit.merchant": "Merchant",
	"TransactionAudit.meta": "Details",
	"TransactionAudit.noEvents": "No events recorded yet",
	"TransactionAudit.page.title": "Transaction Audit",
	"TransactionAudit.payload": "Payload",
	"TransactionAudit.processingId": "Processing ID",
	"TransactionAudit.search": "Search",
	"TransactionAudit.searching": "Searching...",
	"TransactionAudit.status": "Status",
	"TransactionAudit.timeline": "Event Timeline",
	"TransactionAudit.title": "Transaction Audit",
	"TransactionAudit.transaction": "Transaction",
	"TransactionsFilters.acquiring.card": "Bank cards",
	"TransactionsFilters.acquiring.phone": "Mobile phones",
	"TransactionsFilters.btn.setFilters": "Filter",
	"TransactionsFilters.category.QR": "QR transactions",
	"TransactionsFilters.category.SBP": "SBP transactions",
	"TransactionsFilters.category.p2p": "P2P transactions",
	"TransactionsFilters.category.payments": "Payments",
	"TransactionsFilters.category.payout": "Payouts",
	"TransactionsFilters.filters.registry": "Payouts by registry",
	"TransactionsFilters.label.chargeback": "Chargeback",
	"TransactionsFilters.label.created": "Created",
	"TransactionsFilters.label.isDataLoading": "Loading...",
	"TransactionsFilters.label.mP2P": "Manual P2P",
	"TransactionsFilters.label.mP2PCreated": "Manual P2P Created",
	"TransactionsFilters.label.mP2PDecline": "Manual P2P Decline",
	"TransactionsFilters.label.mP2PPending": "Manual P2P Pending",
	"TransactionsFilters.label.mobilePayout": "Mobile Payout",
	"TransactionsFilters.label.mobilePayoutCreated": "Mobile Payout Created",
	"TransactionsFilters.label.mobilePayoutDecline": "Mobile Payout Decline",
	"TransactionsFilters.label.mobilePayoutPending": "Mobile Payout Pending",
	"TransactionsFilters.label.payout": "Payout",
	"TransactionsFilters.label.payoutCreated": "Payout created",
	"TransactionsFilters.label.payoutDecline": "Payout decline",
	"TransactionsFilters.label.payoutPending": "Payout pending",
	"TransactionsFilters.label.purchase": "Purchase",
	"TransactionsFilters.label.purchaseCreated": "Purchase created",
	"TransactionsFilters.label.purchaseDecline": "Purchase decline",
	"TransactionsFilters.label.purchasePending": "Purchase pending",
	"TransactionsFilters.label.qr": "QR Successful",
	"TransactionsFilters.label.qrCreated": "QR Created",
	"TransactionsFilters.label.qrDecline": "QR Decline",
	"TransactionsFilters.label.qrPending": "QR Pending",
	"TransactionsFilters.label.recurrent": "Recurrent",
	"TransactionsFilters.label.recurrentCreated": "Recurrent created",
	"TransactionsFilters.label.recurrentDecline": "Recurrent decline",
	"TransactionsFilters.label.recurrentPending": "Recurrent pending",
	"TransactionsFilters.label.refund": "Refund",
	"TransactionsFilters.label.refundCreated": "Refund created",
	"TransactionsFilters.label.refundDecline": "Refund decline",
	"TransactionsFilters.label.refundPending": "Refund pending",
	"TransactionsFilters.label.reversal": "Reversal",
	"TransactionsFilters.label.reversalCreated": "Reversal created",
	"TransactionsFilters.label.reversalDecline": "Reversal decline",
	"TransactionsFilters.label.reversalPending": "Reversal pending",
	"TransactionsFilters.label.sbp": "SBP",
	"TransactionsFilters.label.sbpCreated": "SBP Created",
	"TransactionsFilters.label.sbpDecline": "SBP Decline",
	"TransactionsFilters.label.sbpPending": "SBP Pending",
	"TransactionsFilters.label.successfulP2P": "Successful P2P",
	"TransactionsFilters.label.successfulSBP": "Successful SBP",
	"TransactionsFilters.label.successfulSbp": "Successful SBP",
	"TransactionsFilters.label.threeDSPending": "3DS Pending",
	"TransactionsFilters.title.acquiring": "Acquiring",
	"TransactionsFilters.title.filters": "Filters",
	"TransactionsFilters.title.statuses": "Statuses",
	"TransactionsTable.amount.confirm": "Change transaction amount {id} to {amount}?",
	"TransactionsTable.amount.error.invalid": "Invalid amount format. Example: 1000 or 1000.50",
	"TransactionsTable.amount.error.required": "Enter an amount",
	"TransactionsTable.amount.error.save": "Failed to change transaction amount",
	"TransactionsTable.amount.note": "Enter the amount in major units; the database stores minor units.",
	"TransactionsTable.amount.placeholder": "For example: 1000 or 1000.50",
	"TransactionsTable.amount.save": "Save",
	"TransactionsTable.amount.saving": "Saving...",
	"TransactionsTable.amount.section": "Change amount",
	"TransactionsTable.amount.success": "Transaction amount updated",
	"TransactionsTable.cancel.cancel": "Cancel ",
	"TransactionsTable.cancel.error": "Payment cancellation is not possible",
	"TransactionsTable.cancel.initiated": "Operation {id} has been {type}.",
	"TransactionsTable.cancel.loading": "Fetching data...",
	"TransactionsTable.cancel.refund": "Refund ",
	"TransactionsTable.cancel.success": "Cancellation initiated",
	"TransactionsTable.check.amount": "Amount:",
	"TransactionsTable.check.button": "Check transaction",
	"TransactionsTable.check.decline": "Move to Decline",
	"TransactionsTable.check.error": "Error while checking transaction",
	"TransactionsTable.check.loading": "Checking...",
	"TransactionsTable.check.message": "Message:",
	"TransactionsTable.check.orderId": "Order ID:",
	"TransactionsTable.check.payout": "Move to Payout",
	"TransactionsTable.check.provider": "Provider:",
	"TransactionsTable.check.result": "Check result:",
	"TransactionsTable.check.rrn": "RRN:",
	"TransactionsTable.check.status": "Status:",
	"TransactionsTable.confirm.action": "Action",
	"TransactionsTable.confirm.decline": "Move transaction {id} to Decline?",
	"TransactionsTable.confirm.payout": "Move transaction {id} to Payout?",
	"TransactionsTable.confirm.text": "Confirm operation",
	"TransactionsTable.empty": "No payments",
	"TransactionsTable.error.cancel": "Payment cancellation is not possible",
	"TransactionsTable.error.decline": "Failed to move transaction to Decline",
	"TransactionsTable.error.payout": "Failed to move transaction to Payout",
	"TransactionsTable.label.chargeback": "Chargeback",
	"TransactionsTable.label.created": "Created",
	"TransactionsTable.label.mP2P": "Manual P2P",
	"TransactionsTable.label.mP2PCreated": "Manual P2P Created",
	"TransactionsTable.label.mP2PDecline": "Manual P2P Decline",
	"TransactionsTable.label.mP2PPending": "Manual P2P Pending",
	"TransactionsTable.label.mobilePayout": "Mobile Payout",
	"TransactionsTable.label.mobilePayoutCreated": "Mobile Payout Created",
	"TransactionsTable.label.mobilePayoutDecline": "Mobile Payout Decline",
	"TransactionsTable.label.mobilePayoutPending": "Mobile Payout Pending",
	"TransactionsTable.label.payout": "Payout",
	"TransactionsTable.label.payoutCreated": "Payout created",
	"TransactionsTable.label.payoutDecline": "Payout decline",
	"TransactionsTable.label.payoutPending": "Payout pending",
	"TransactionsTable.label.purchase": "Purchase",
	"TransactionsTable.label.purchaseCreated": "Purchase created",
	"TransactionsTable.label.purchaseDecline": "Purchase decline",
	"TransactionsTable.label.purchasePending": "Purchase pending",
	"TransactionsTable.label.qr": "QR Successful",
	"TransactionsTable.label.qrCreated": "QR Created",
	"TransactionsTable.label.qrDecline": "QR Decline",
	"TransactionsTable.label.qrPending": "QR Pending",
	"TransactionsTable.label.recurrent": "Recurrent",
	"TransactionsTable.label.recurrentCreated": "Recurrent created",
	"TransactionsTable.label.recurrentDecline": "Recurrent decline",
	"TransactionsTable.label.recurrentPending": "Recurrent pending",
	"TransactionsTable.label.refund": "Refund",
	"TransactionsTable.label.refundCreated": "Refund created",
	"TransactionsTable.label.refundDecline": "Refund decline",
	"TransactionsTable.label.refundPending": "Refund pending",
	"TransactionsTable.label.reversal": "Reversal",
	"TransactionsTable.label.reversalCreated": "Reversal created",
	"TransactionsTable.label.reversalDecline": "Reversal decline",
	"TransactionsTable.label.reversalPending": "Reversal pending",
	"TransactionsTable.label.sbp": "SBP",
	"TransactionsTable.label.sbpCreated": "SBP Created",
	"TransactionsTable.label.sbpDecline": "SBP Decline",
	"TransactionsTable.label.sbpPending": "SBP Pending",
	"TransactionsTable.label.successfulP2P": "Successful P2P",
	"TransactionsTable.label.successfulSBP": "Successful SBP",
	"TransactionsTable.label.successfulSbp": "Successful SBP",
	"TransactionsTable.label.threeDSPending": "3DS Pending",
	"TransactionsTable.modal.refund": "Refund {amount}",
	"TransactionsTable.modal.reversal": "Cancel payment {amount}",
	"TransactionsTable.modal.title": "Confirm action",
	"TransactionsTable.refund.action": "Action",
	"TransactionsTable.refund.button": "Refund",
	"TransactionsTable.refund.id": "Refund transaction ID",
	"TransactionsTable.refund.initiated": "Refund initiated",
	"TransactionsTable.refund.loading": "Loading data...",
	"TransactionsTable.refund.status": "Status",
	"TransactionsTable.refund.type": "Type",
	"TransactionsTable.resend.button": "Resend to merchant",
	"TransactionsTable.resend.buttonDeposit": "Retry crediting",
	"TransactionsTable.resend.confirm": "Resend the notification for transaction {id} to the merchant?",
	"TransactionsTable.resend.confirmDeposit": "Retry delivering deposit {id} to the merchant?",
	"TransactionsTable.resend.confirmReopen": "Deposit {id} was declined by the merchant. It will be sent to the merchant again and, if accepted, credited to the merchant balance (amount minus fee). Continue?",
	"TransactionsTable.resend.error": "Failed to resend to the merchant",
	"TransactionsTable.resend.flow.agent_deposit": "agent deposit",
	"TransactionsTable.resend.flow.craft_lite": "Paycraft (lite)",
	"TransactionsTable.resend.flow.fins_lite": "FinStar (lite)",
	"TransactionsTable.resend.flow.hydra_lite": "Hydracode (lite)",
	"TransactionsTable.resend.flow.npay_lite": "NPay (lite)",
	"TransactionsTable.resend.flow.queue": "regular notification (queue)",
	"TransactionsTable.resend.result.flow": "Format: {flow}",
	"TransactionsTable.resend.result.host": "Address: {host}",
	"TransactionsTable.resend.result.httpCode": "Merchant response: HTTP {code}",
	"TransactionsTable.resend.sending": "Sending...",
	"TransactionsTable.reversal.action": "Action",
	"TransactionsTable.reversal.button": "Cancel payment",
	"TransactionsTable.reversal.canceled": "Payment canceled",
	"TransactionsTable.reversal.id": "Cancellation transaction ID",
	"TransactionsTable.reversal.loading": "Loading data...",
	"TransactionsTable.reversal.status": "Status",
	"TransactionsTable.reversal.type": "Type",
	"TransactionsTable.status.loading": "Waiting for response...",
	"TransactionsTable.status.waiting": "Status",
	"TransactionsTable.success.cancel": "Cancellation initiated",
	"TransactionsTable.success.decline": "Transaction status updated to Decline",
	"TransactionsTable.success.payout": "Transaction status updated to Payout",
	"TransactionsTable.tab.action": "Action:",
	"TransactionsTable.tab.actions": "Actions",
	"TransactionsTable.tab.amount": "Amount:",
	"TransactionsTable.tab.audit": "Audit",
	"TransactionsTable.tab.bank": "Card bank:",
	"TransactionsTable.tab.cancelId": "ID",
	"TransactionsTable.tab.cancelType": "Operation type",
	"TransactionsTable.tab.cardHolder": "Cardholder:",
	"TransactionsTable.tab.confirm": "Confirmation",
	"TransactionsTable.tab.country": "Card country:",
	"TransactionsTable.tab.email": "E-mail:",
	"TransactionsTable.tab.extStatus": "Extended status:",
	"TransactionsTable.tab.extendedStatus": "Extended status:",
	"TransactionsTable.tab.fee": "Fee:",
	"TransactionsTable.tab.id": "Transaction ID:",
	"TransactionsTable.tab.management": "Management",
	"TransactionsTable.tab.parameters": "Payment parameters",
	"TransactionsTable.tab.params": "Payment parameters",
	"TransactionsTable.tab.payment": "Payment data",
	"TransactionsTable.tab.paymentData": "Payment data",
	"TransactionsTable.tab.phone": "Phone:",
	"TransactionsTable.tab.processId": "Process ID:",
	"TransactionsTable.tab.processed": "Processed:",
	"TransactionsTable.tab.refund": "Refund",
	"TransactionsTable.tab.rrn": "RRN:",
	"TransactionsTable.tab.status": "Status",
	"TransactionsTable.tab.waiting": "Waiting for response...",
	"TransactionsTable.table.amount": "Amount",
	"TransactionsTable.table.date": "Date",
	"TransactionsTable.table.payer": "Payer",
	"TransactionsTable.table.project": "Project",
	"TransactionsTable.text.paymentPartialRefund": "Partial refund is available for this transaction. Maximum amount {amount}. Return time depends on the issuing bank and ranges from 1 to 7 business days.",
	"TransactionsTable.text.paymentPartialReversal": "Partial reversal is available for this transaction. Maximum amount {amount}. Reversal time depends on the issuing bank and usually occurs within an hour.",
	"TransactionsTable.text.paymentRefund": "A refund will be made in the amount of {amount}. The return time depends on the issuing bank and ranges from 1 to 7 business days.",
	"TransactionsTable.text.paymentReversal": "The payment will be canceled for the amount {amount}. Cancellation time depends on the issuing bank and usually occurs within an hour.",
	"UserMenu.list.home": "Home",
	"UserMenu.list.projects": "Projects",
	"UserMenu.list.transactions": "Transactions",
	"UserMenu.title.antifraud": "Antifraud System",
	"UserMenu.title.antifraudFileCheck": "File Check",
	"UserMenu.title.antifraudLog": "Antifraud Log",
	"UserMenu.title.antifraudSingleCheck": "Single Check",
	"UserMenu.title.finance": "Finance",
	"UserMenu.title.metal": "Metal",
	"UserMenu.title.mobileRegistries": "Registries (SBP)",
	"UserMenu.title.payments": "Payments",
	"UserMenu.title.payouts": "Payouts",
	"UserMenu.title.prepaid": "Activated cards",
	"UserMenu.title.registries": "Registries",
	"UserMenu.title.sbpPayouts": "Payouts (SBP)",
	"UserMenu.title.sbpRegistries": "Registries (SBP)",
	"UserMenu.title.statement": "Statement",
	"UserSearchList.empty": "Nothing found",
	"UserSearchList.loading": "Loading users...",
	"UserSearchList.permissions.btn": "Permissions",
	"UserSearchList.permissions.title": "Configure permissions",
	"UserSearchList.placeholder": "Search user by ID, name or email...",
	"UserSearchList.remove.aria": "Remove {name}",
	"UserSearchList.selected.title": "Selected users",
	"binBase.country.0": "United States of America",
	"binBase.country.10": "Antarctic",
	"binBase.country.100": "Bulgaria",
	"binBase.country.104": "Myanmar",
	"binBase.country.108": "Burundi",
	"binBase.country.112": "Belarus",
	"binBase.country.116": "Cambodia",
	"binBase.country.12": "Algeria",
	"binBase.country.120": "Cameroon",
	"binBase.country.124": "Canada",
	"binBase.country.132": "Cape Verde",
	"binBase.country.136": "Cayman Islands",
	"binBase.country.140": "Central African Republic",
	"binBase.country.144": "Sri Lanka",
	"binBase.country.148": "Chad",
	"binBase.country.152": "Chile",
	"binBase.country.156": "China",
	"binBase.country.158": "Taiwan",
	"binBase.country.16": "American Samoa",
	"binBase.country.162": "Christmas Island",
	"binBase.country.166": "Cocos (Keeling) Islands",
	"binBase.country.170": "Colombia",
	"binBase.country.174": "Comoros",
	"binBase.country.175": "Mayotte",
	"binBase.country.178": "Congo",
	"binBase.country.180": "Congo, Democratic Republic of the",
	"binBase.country.184": "Cook Islands",
	"binBase.country.188": "Costa Rica",
	"binBase.country.191": "Croatia",
	"binBase.country.192": "Cuba",
	"binBase.country.196": "Cyprus",
	"binBase.country.20": "Andorra",
	"binBase.country.203": "Czech Republic",
	"binBase.country.204": "Benin",
	"binBase.country.208": "Denmark",
	"binBase.country.212": "Dominica",
	"binBase.country.214": "Dominican Republic",
	"binBase.country.218": "Ecuador",
	"binBase.country.222": "El Salvador",
	"binBase.country.226": "Equatorial Guinea",
	"binBase.country.231": "Ethiopia",
	"binBase.country.232": "Eritrea",
	"binBase.country.233": "Estonia",
	"binBase.country.234": "Faroe Islands",
	"binBase.country.238": "Falkland (Malvinas) Islands",
	"binBase.country.239": "South Georgia and the South Sandwich Islands",
	"binBase.country.24": "Angola",
	"binBase.country.242": "Fiji",
	"binBase.country.246": "Finland",
	"binBase.country.250": "France",
	"binBase.country.254": "French Guiana",
	"binBase.country.258": "French Polynesia",
	"binBase.country.260": "French Southern Territories",
	"binBase.country.262": "Djibouti",
	"binBase.country.266": "Gabon",
	"binBase.country.268": "Georgia",
	"binBase.country.270": "Gambia",
	"binBase.country.275": "Palestinian Territory (occupied)",
	"binBase.country.276": "Germany",
	"binBase.country.28": "Antigua and Barbuda",
	"binBase.country.280": "Germany",
	"binBase.country.288": "Ghana",
	"binBase.country.292": "Gibraltar",
	"binBase.country.296": "Kiribati",
	"binBase.country.300": "Greece",
	"binBase.country.304": "Greenland",
	"binBase.country.308": "Grenada",
	"binBase.country.31": "Azerbaijan",
	"binBase.country.312": "Guadeloupe",
	"binBase.country.316": "Guam",
	"binBase.country.32": "Argentina",
	"binBase.country.320": "Guatemala",
	"binBase.country.324": "Guinea",
	"binBase.country.328": "Guyana",
	"binBase.country.332": "Haiti",
	"binBase.country.334": "Heard and McDonald Islands",
	"binBase.country.336": "Vatican (Holy See)",
	"binBase.country.340": "Honduras",
	"binBase.country.344": "Hong Kong",
	"binBase.country.348": "Hungary",
	"binBase.country.352": "Iceland",
	"binBase.country.356": "India",
	"binBase.country.36": "Australia",
	"binBase.country.360": "Indonesia",
	"binBase.country.364": "Iran",
	"binBase.country.368": "Iraq",
	"binBase.country.372": "Ireland",
	"binBase.country.376": "Israel",
	"binBase.country.380": "Italy",
	"binBase.country.384": "Cote d'Ivoire",
	"binBase.country.388": "Jamaica",
	"binBase.country.392": "Japan",
	"binBase.country.398": "Kazakhstan",
	"binBase.country.4": "Afghanistan",
	"binBase.country.40": "Austria",
	"binBase.country.400": "Jordan",
	"binBase.country.404": "Kenya",
	"binBase.country.408": "Korea (North)",
	"binBase.country.410": "Korea (South)",
	"binBase.country.414": "Kuwait",
	"binBase.country.417": "Kyrgyzstan",
	"binBase.country.418": "Lao People's Democratic Republic",
	"binBase.country.422": "Lebanon",
	"binBase.country.426": "Lesotho",
	"binBase.country.428": "Latvia",
	"binBase.country.430": "Liberia",
	"binBase.country.434": "Libya",
	"binBase.country.438": "Liechtenstein",
	"binBase.country.44": "Bahamas",
	"binBase.country.440": "Lithuania",
	"binBase.country.442": "Luxembourg",
	"binBase.country.446": "Macau (Macao)",
	"binBase.country.450": "Madagascar",
	"binBase.country.454": "Malawi",
	"binBase.country.458": "Malaysia",
	"binBase.country.462": "Maldives",
	"binBase.country.466": "Mali",
	"binBase.country.470": "Malta",
	"binBase.country.474": "Martinique",
	"binBase.country.478": "Mauritania",
	"binBase.country.48": "Bahrain",
	"binBase.country.480": "Mauritius",
	"binBase.country.484": "Mexico",
	"binBase.country.492": "Monaco",
	"binBase.country.496": "Mongolia",
	"binBase.country.498": "Moldova",
	"binBase.country.499": "Montenegro",
	"binBase.country.50": "Bangladesh",
	"binBase.country.500": "Montserrat",
	"binBase.country.504": "Morocco",
	"binBase.country.508": "Mozambique",
	"binBase.country.51": "Armenia",
	"binBase.country.512": "Oman",
	"binBase.country.516": "Namibia",
	"binBase.country.52": "Barbados",
	"binBase.country.520": "Nauru",
	"binBase.country.524": "Nepal",
	"binBase.country.528": "Netherlands",
	"binBase.country.530": "Netherlands Antilles",
	"binBase.country.531": "CURACAO",
	"binBase.country.533": "Aruba",
	"binBase.country.534": "Sint Maarten",
	"binBase.country.535": "Bonaire, Sint Eustatius and Saba",
	"binBase.country.540": "New Caledonia",
	"binBase.country.548": "Vanuatu",
	"binBase.country.554": "New Zealand",
	"binBase.country.558": "Nicaragua",
	"binBase.country.56": "Belgium",
	"binBase.country.562": "Niger",
	"binBase.country.566": "Nigeria",
	"binBase.country.570": "Niue",
	"binBase.country.574": "Norfolk Island",
	"binBase.country.578": "Norway",
	"binBase.country.580": "Northern Mariana Islands",
	"binBase.country.581": "United States Minor Outlying Islands",
	"binBase.country.583": "Federated States of Micronesia",
	"binBase.country.584": "Marshall Islands",
	"binBase.country.585": "Palau",
	"binBase.country.586": "Pakistan",
	"binBase.country.591": "Panama",
	"binBase.country.598": "Papua New Guinea",
	"binBase.country.60": "Bermuda",
	"binBase.country.600": "Paraguay",
	"binBase.country.604": "Peru",
	"binBase.country.608": "Philippines",
	"binBase.country.612": "Pitcairn",
	"binBase.country.616": "Poland",
	"binBase.country.620": "Portugal",
	"binBase.country.624": "Guinea-Bissau",
	"binBase.country.626": "East Timor (TL, TLS)",
	"binBase.country.630": "Puerto Rico",
	"binBase.country.634": "Qatar",
	"binBase.country.638": "Reunion",
	"binBase.country.64": "Bhutan",
	"binBase.country.642": "Romania (ROU)",
	"binBase.country.643": "Russia (Russian Federation)",
	"binBase.country.646": "Rwanda",
	"binBase.country.654": "St. Helena",
	"binBase.country.659": "Saint Kitts (Christopher) and Nevis",
	"binBase.country.660": "Anguilla",
	"binBase.country.662": "Saint Lucia",
	"binBase.country.666": "St. Pierre and Miquelon",
	"binBase.country.670": "Saint Vincent and the Grenadines",
	"binBase.country.674": "San Marino",
	"binBase.country.678": "Sao Tome and Principe",
	"binBase.country.68": "Bolivia",
	"binBase.country.682": "Saudi Arabia",
	"binBase.country.686": "Senegal",
	"binBase.country.688": "Serbia",
	"binBase.country.690": "Seychelles",
	"binBase.country.694": "Sierra Leone",
	"binBase.country.70": "Bosnia & Herzegovina",
	"binBase.country.702": "Singapore",
	"binBase.country.703": "Slovak Republic",
	"binBase.country.704": "Vietnam",
	"binBase.country.705": "Slovenia",
	"binBase.country.706": "Somalia",
	"binBase.country.710": "South Africa",
	"binBase.country.716": "Zimbabwe",
	"binBase.country.72": "Botswana",
	"binBase.country.724": "Spain",
	"binBase.country.728": "South Sudan",
	"binBase.country.729": "Sudan",
	"binBase.country.732": "Western Sahara",
	"binBase.country.736": "Sudan",
	"binBase.country.74": "Bouvet Island",
	"binBase.country.740": "Suriname",
	"binBase.country.744": "Svalbard and Jan Mayen Islands",
	"binBase.country.748": "Eswatini",
	"binBase.country.752": "Sweden",
	"binBase.country.756": "Switzerland",
	"binBase.country.76": "Brazil",
	"binBase.country.760": "Syria",
	"binBase.country.762": "Tajikistan",
	"binBase.country.764": "Thailand",
	"binBase.country.768": "Togo",
	"binBase.country.772": "Tokelau",
	"binBase.country.776": "Tonga",
	"binBase.country.780": "Trinidad and Tobago",
	"binBase.country.784": "United Arab Emirates",
	"binBase.country.788": "Tunisia",
	"binBase.country.792": "Turkey",
	"binBase.country.795": "Turkmenistan",
	"binBase.country.796": "Turks and Caicos Islands",
	"binBase.country.798": "Tuvalu",
	"binBase.country.8": "Albania",
	"binBase.country.800": "Uganda",
	"binBase.country.804": "Ukraine",
	"binBase.country.807": "North Macedonia",
	"binBase.country.818": "Egypt",
	"binBase.country.826": "United Kingdom",
	"binBase.country.831": "Guernsey",
	"binBase.country.832": "Jersey",
	"binBase.country.833": "Isle of Man",
	"binBase.country.834": "Tanzania",
	"binBase.country.84": "Belize",
	"binBase.country.840": "United States of America",
	"binBase.country.850": "Virgin Islands, US",
	"binBase.country.854": "Burkina Faso",
	"binBase.country.858": "Uruguay",
	"binBase.country.86": "British Indian Ocean Territory",
	"binBase.country.860": "Uzbekistan",
	"binBase.country.862": "Venezuela",
	"binBase.country.876": "Wallis and Futuna Islands",
	"binBase.country.882": "Samoa",
	"binBase.country.887": "Yemen",
	"binBase.country.891": "Yugoslavia",
	"binBase.country.894": "Zambia",
	"binBase.country.90": "Solomon Islands",
	"binBase.country.92": "Virgin Islands, British",
	"binBase.country.96": "Brunei Darussalam",
	"binBase.country.999": "Kosovo"
};


//////////////////
// WEBPACK FOOTER
// ./src/translation/en.json
// module id = 664
// module chunks = 0